import { render, staticRenderFns } from "./PurchaseInvoiceDetail.vue?vue&type=template&id=0723694b&scoped=true"
import script from "./PurchaseInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInvoiceDetail.vue?vue&type=style&index=0&id=0723694b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0723694b",
  null
  
)

export default component.exports